<app-breadcrumb [title]="'Contacto'" [breadcrumb]="'Contacto'"></app-breadcrumb>
<!--section start-->
<section class=" contact-page section-b-space">
    <div class="container">
        <div class="row section-b-space">
            <div class="col-lg-7 map">
                <!-- <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3764.9762272687117!2d-99.1431222260418!3d19.326837844052438!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85ce01cdf93bcfb9%3A0x5290a37c88d1bf68!2sAv.%20Divisi%C3%B3n%20del%20Nte.%203454%2C%20Xotepingo%2C%20Coyoac%C3%A1n%2C%2004610%20Ciudad%20de%20M%C3%A9xico%2C%20CDMX%2C%20M%C3%A9xico!5e0!3m2!1ses!2spe!4v1704402771962!5m2!1ses!2spe" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe> -->
                <!-- <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3764.9762272687117!2d-99.1431222260418!3d19.326837844052438!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85ce01cdf93bcfb9%3A0x5290a37c88d1bf68!2sAv.%20Divisi%C3%B3n%20del%20Nte.%203454%2C%20Xotepingo%2C%20Coyoac%C3%A1n%2C%2004610%20Ciudad%20de%20M%C3%A9xico%2C%20CDMX%2C%20M%C3%A9xico!5e0!3m2!1ses!2spe!4v1704402771962!5m2!1ses!2spe"   allowfullscreen></iframe> -->
                <!-- <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3763.238004682654!2d-99.27795431510202!3d19.402119894924983!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85d2013580bdc8cf%3A0x3b36518ea884b24a!2sVia%20Magna%2019-piso%205%2C%20Bosque%20de%20las%20Palmas%2C%2052786%20Naucalpan%20de%20Ju%C3%A1rez%2C%20M%C3%A9x.!5e0!3m2!1ses!2smx!4v1735588743135!5m2!1ses!2smx" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe> -->
                <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3764.1768204429463!2d-99.18534342418889!3d19.361494942946702!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85d1ff8cc3a83203%3A0x59a3e564a2bd582e!2sAv.%20Insurgentes%20Sur%201666%2C%20Florida%2C%20%C3%81lvaro%20Obreg%C3%B3n%2C%2001030%20Ciudad%20de%20M%C3%A9xico%2C%20CDMX!5e0!3m2!1ses!2smx!4v1742339534737!5m2!1ses!2smx"
                    width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy"
                    referrerpolicy="no-referrer-when-downgrade"></iframe>
            </div>
            <div class="col-lg-5">
                <div class="contact-right">
                    <ul>
                        <li>
                            <div class="contact-icon">
                                <img src="assets/images/icon/whatsapp.png" alt="Generic placeholder image"
                                    style="width: 20px; height: 20px;">
                                <h6>Whatsapp</h6>
                            </div>
                            <a class="media-body" href="https://api.whatsapp.com/send?phone=5562017200">
                                <p>+52 55 29 91 45 50</p>
                            </a>
                        </li>
                        <li>
                            <div class="contact-icon">
                                <i class="fa fa-map-marker" aria-hidden="true"></i>
                                <h6>Dirección</h6>
                            </div>
                            <div class="media-body">
                                <p>Av. Insurgentes Sur 1666 Col. Florida,</p>
                                <p>01030, Álvaro Obregón, Ciudad de México.</p>
                            </div>
                        </li>
                        <li>
                            <div class="contact-icon">
                                <i class="fa fa-envelope"></i>
                                <!--<img src="assets/images/icon/email.png" alt="Generic placeholder image">-->
                                <h6>E-mail</h6>
                            </div>
                            <div class="media-body">
                                <p>contacto&#64;GIGMAX.mx</p>
                                <!-- <p>integraciones.validacion@openpay.mx</p> -->
                            </div>
                        </li>
                        <li>
                            <div class="contact-icon">
                                <i class="fa fa-globe" aria-hidden="true"></i>
                                <h6>Sitio web</h6>
                            </div>
                            <div class="media-body">
                                <p>http://gigmax.mx/</p>
                                <!--<p>info@shopcart.com</p>-->
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="row section-b-space login-page">
            <div class="col-sm-12 theme-card">
                <form class="theme-form row" [formGroup]="formContacto" novalidate>
                    <div class="row">
                        <div class="col-md-6 mt-2">
                            <label for="nombre">Nombre</label>
                            <input type="text" class="form-control" id="nombre" placeholder="Nombre"
                                formControlName="nombre" required>
                            <div class="text-dangerr" [@fadeInUp]
                                *ngIf="(formContacto.get('nombre').touched) && formContacto.get('nombre').errors?.required">
                                Campo requerido
                            </div>
                        </div>
                        <div class="col-md-6 mt-2">
                            <label for="apellidos">Apellidos</label>
                            <input type="text" class="form-control" id="apellidos" placeholder="Apellidos"
                                formControlName="apellidos" required>
                            <div class="text-dangerr" [@fadeInUp]
                                *ngIf="(formContacto.get('apellidos').touched) && formContacto.get('apellidos').errors?.required">
                                Campo requerido
                            </div>
                        </div>
                        <div class="col-md-6 mt-2">
                            <label for="telefono">Teléfono</label>
                            <input type="text" class="form-control" id="telefono" placeholder="Número telefónico"
                                formControlName="telefono" required>
                            <div class="text-dangerr" [@fadeInUp]
                                *ngIf="(formContacto.get('telefono').touched) && formContacto.get('telefono').errors?.required">
                                Campo requerido
                            </div>
                        </div>
                        <div class="col-md-6 mt-2">
                            <label for="correo">Correo electrónico</label>
                            <input type="email" class="form-control" id="correo" placeholder="Correo electrónico"
                                formControlName="correo" required>
                            <div class="text-dangerr" [@fadeInUp]
                                *ngIf="(formContacto.get('correo').touched) && formContacto.get('correo').errors?.required">
                                Campo requerido
                            </div>
                            <div class="text-dangerr" *ngIf="isControlHasError('correo','email')">
                                <strong>Este no es un correo valido</strong>
                            </div>
                        </div>
                        <div class="col-md-12 mt-2">
                            <label for="mensaje">Mensaje:</label>
                            <textarea class="form-control" placeholder="Escribir mensaje" id="mensaje" rows="6"
                                formControlName="mensaje" required></textarea>
                            <div class="text-dangerr" [@fadeInUp]
                                *ngIf="(formContacto.get('mensaje').touched) && formContacto.get('mensaje').errors?.required">
                                Campo requerido
                            </div>
                        </div>
                        <div class="col-md-12 mt-2">
                            <button class="btn btn-solid" [disabled]="formContacto.invalid" (click)="agregar()">Enviar
                                comentarios</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</section>
<!--Section ends-->